import {css} from "@emotion/react";
import React from 'react';
import {DetailsIcon} from "../../../AirQualityMonitoring/components/DataListCard/components/DetailsIcon";
import {Table, TableProps} from "../../../AirQualityMonitoring/components/DataListCard/components/Table";
import {useAuth} from "../../../Auth";
import {TSMMonitoringContext} from "../../components/TSMMonitoringProvider";
import {EditSvgIcon} from "../EditSvgIcon";
import {useAlertTrainsByPeriod} from "../../../../sdk/queries";
import moment from "moment"

export interface DustAlertTrainsTableProps {
    onView?(id: number): void;
    location_id: number,
    period_s: string
}

export const DustAlertTrainsTable: React.FC<DustAlertTrainsTableProps> = ({
    onView,
    location_id,
    period_s
}) => {


    const a_trains = useAlertTrainsByPeriod({
	variables: {
	    id: String(location_id),
	    period_date: period_s,
	}
    });

    const alertTrains = (a_trains?.data?.data || []);
    
    const trainListData: TableProps['data'] = [{
        name: "Train ID",
        values: alertTrains.map(x => x.name),
    }, {
        name: "Train Pass Date/Time",
        values: alertTrains.map(x => moment(x.start_at).format("MM-DD-yyyy HH:mm")),
    }, {
      name: "Has Met Coal",
      values: alertTrains.map(x => x.met_train),
    }, {
      name: "Speed",
      values: alertTrains.map(x => x.avg_speed != null ? x.avg_speed : "--"),
    },{
      name: "Details",
      values: alertTrains.map(x => <div css={css({
        display: "flex",
        flex: 1,
        alignItems: "center",
        width: 80,
        justifyContent: "center",
      })}>

        <DetailsIcon
          onClick={() => onView?.(x.id)}/>
      </div>),
    }];

  return (
    <Table data={trainListData} fullWidth={true}/>
  );
}
